import React from 'react';
import { DateRange, FunctionType } from '@/types/item';
import { calculateBarPosition } from '../utils/liteTimelineUtils';

interface LiteBarProps {
  dateRange: DateRange;
  functionType: FunctionType;
  viewportStart: string;
  viewportEnd: string;
  height?: number;
  top?: number;
  opacity?: number;
  hasWarning?: boolean;
  isComplete?: boolean;
  className?: string;
}

const functionColors: Record<FunctionType, string> = {
  shop: 'var(--chart-1)',
  specs: 'var(--chart-2)',
  po: 'var(--chart-3)',
  contract: 'var(--chart-4)'
};

const LiteBar: React.FC<LiteBarProps> = ({
  dateRange,
  functionType,
  viewportStart,
  viewportEnd,
  height = 8,
  top = 2,
  opacity = 0.9,
  hasWarning = false,
  isComplete = false,
  className = ''
}) => {
  const { left, width, isVisible } = calculateBarPosition(
    dateRange,
    viewportStart,
    viewportEnd,
    32
  );

  if (!isVisible || width <= 0) return null;

  return (
    <div
      className={`absolute rounded-sm transition-all ${className}`}
      style={{
        left,
        width,
        height,
        top,
        backgroundColor: `hsl(${functionColors[functionType]})`,
        opacity,
        pointerEvents: 'none',
        border: hasWarning
          ? '2px solid hsl(var(--destructive))'
          : isComplete
            ? '2px solid hsl(var(--chart-1))'
            : 'none',
      }}
    />
  );
};

export default React.memo(LiteBar);
